// extracted by mini-css-extract-plugin
module.exports = {"pageContainer":"SignUpPage_pageContainer__h9tWl","workableArea":"SignUpPage_workableArea__2TDIB","upperContainer":"SignUpPage_upperContainer__2PbiH"};